import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

import { BLACK, PRIMARY_PURPLE } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const defaultInputStyle = {
  width: '300px',
  '& .MuiInputLabel-root': {
    color: BLACK[100],
    fontFamily: PRIMARY_FONT[400],
    marginBottom: '8px',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: PRIMARY_PURPLE[70],
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: BLACK[100],
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px) scale(0.75)',
  },
  '& .MuiOutlinedInput-root': {
    marginTop: '8px',
  },
};

const WaeStandardTextField = ({
  label,
  value,
  onChange,
  error,
  helperText,
  required = false,
  disabled = false,
  placeholder,
  fullWidth = false,
  multiline = false,
  rows,
  maxRows,
  minRows,
  sx,
  testId,
  validate, // Future validation function prop
  ...otherProps
}) => {
  // For future validation function support
  const validationError = validate ? validate(value) : null;
  const hasError = error || !!validationError;
  const displayHelperText = helperText || validationError;

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      error={hasError}
      helperText={displayHelperText}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      maxRows={maxRows}
      minRows={minRows}
      sx={{ ...defaultInputStyle, ...sx }}
      data-testid={testId}
      variant="outlined"
      {...otherProps}
    />
  );
};

WaeStandardTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  sx: PropTypes.shape({}),
  testId: PropTypes.string,
  validate: PropTypes.func, // Future validation function
};

export default WaeStandardTextField;
